export default __webpack_public_path__ + "static/media/andes_a_la_costa_25.98e34ae9.JPG";